// AUTO-GENERATED. Edit cautiously.

import { Export } from "devextreme-react/data-grid";

// ===== Address =====
export const CREATE_ADDRESS = "CREATE_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const GET_ADDRESS = "GET_ADDRESS";
export const GET_ADDRESS_RESPONSE = "GET_ADDRESS_RESPONSE";
export const GET_ALL_ADDRESS = "GET_ALL_ADDRESS";
export const GET_ALL_ADDRESS_RESPONSE = "GET_ALL_ADDRESS_RESPONSE";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";

// ===== Banner =====
export const CREATE_BANNER = "CREATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const GET_ALL_BANNER = "GET_ALL_BANNER";
export const GET_ALL_BANNER_RESPONSE = "GET_ALL_BANNER_RESPONSE";
export const GET_BANNER = "GET_BANNER";
export const GET_BANNER_RESPONSE = "GET_BANNER_RESPONSE";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const GET_INACTIVE_BANNER = "GET_INACTIVE_BANNER";

// ===== BlogCategory =====
export const CREATE_BLOG_CATEGORY = "CREATE_BLOG_CATEGORY";
export const DELETE_BLOG_CATEGORY = "DELETE_BLOG_CATEGORY";
export const GET_ACTIVE_BLOG_CATEGORY = "GET_ACTIVE_BLOG_CATEGORY";
export const GET_ACTIVE_BLOG_CATEGORY_RESPONSE =
  "GET_ACTIVE_BLOG_CATEGORY_RESPONSE";
export const GET_ALL_BLOG_CATEGORY = "GET_ALL_BLOG_CATEGORY";
export const GET_ALL_BLOG_CATEGORY_RESPONSE = "GET_ALL_BLOG_CATEGORY_RESPONSE";
export const GET_BLOG_CATEGORY_BY_ID = "GET_BLOG_CATEGORY_BY_ID";
export const GET_BLOG_CATEGORY_BY_ID_RESPONSE =
  "GET_BLOG_CATEGORY_BY_ID_RESPONSE";
export const UPDATE_BLOG_CATEGORY = "UPDATE_BLOG_CATEGORY";

// ===== Blogs =====
export const CREATE_BLOGS = "CREATE_BLOGS";
export const DELETE_BLOGS = "DELETE_BLOGS";
export const GET_ALL_BLOGS = "GET_ALL_BLOGS";
export const GET_ALL_BLOGS_RESPONSE = "GET_ALL_BLOGS_RESPONSE";
export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOGS_RESPONSE = "GET_BLOGS_RESPONSE";
export const UPDATE_BLOGS = "UPDATE_BLOGS";
export const GET_ACTIVE_BLOG = "GET_ACTIVE_BLOG";
export const GET_ACTIVE_BLOG_RESPONSE = "GET_ACTIVE_BLOG_RESPONSE";
export const GET_INACTIVE_BLOG = "GET_INACTIVE_BLOG";
export const GET_INACTIVE_BLOG_RESPONSE = "GET_INACTIVE_BLOG_RESPONSE";

// ===== Category =====
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const GET_ALL_CATEGORY = "GET_ALL_CATEGORY";
export const GET_ALL_CATEGORY_RESPONSE = "GET_ALL_CATEGORY_RESPONSE";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_CATEGORY_RESPONSE = "GET_CATEGORY_RESPONSE";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";

// ===== Customer =====
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const GET_ALL_CUSTOMER = "GET_ALL_CUSTOMER";
export const GET_ALL_CUSTOMER_RESPONSE = "GET_ALL_CUSTOMER_RESPONSE";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_RESPONSE = "GET_CUSTOMER_RESPONSE";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const GET_CUSTOMER_ID = "GET_CUSTOMER_ID";

// ===== Offer =====
export const CREATE_OFFER = "CREATE_OFFER";
export const DELETE_OFFER = "DELETE_OFFER";
export const GET_ALL_OFFER = "GET_ALL_OFFER";
export const GET_ALL_OFFER_RESPONSE = "GET_ALL_OFFER_RESPONSE";
export const GET_OFFER = "GET_OFFER";
export const GET_OFFER_RESPONSE = "GET_OFFER_RESPONSE";
export const UPDATE_OFFER = "UPDATE_OFFER";

// ===== Orders =====
export const CREATE_ORDERS = "CREATE_ORDERS";
export const DELETE_ORDERS = "DELETE_ORDERS";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_ALL_ORDERS_RESPONSE = "GET_ALL_ORDERS_RESPONSE";
export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDERS_BY_CUSTOMER_ID = "GET_ORDERS_BY_CUSTOMER_ID";
export const GET_PACKED_ORDERS = "GET_PACKED_ORDERS";
export const GET_PENDING_ORDERS = "GET_PENDING_ORDERS";
export const GET_SHIPPED_ORDERS = "GET_SHIPPED_ORDERS";
export const GET_ORDERS_RESPONSE = "GET_ORDERS_RESPONSE";
export const UPDATE_ORDERS = "UPDATE_ORDERS";
export const GET_DELIVERY_ORDERS = "GET_DELIVERY_ORDERS";
export const GET_ORDERS_BY_BUNDLE_ID = "GET_ORDERS_BY_BUNDLE_ID";

export const GET_CART_BUNDLE_ID_ORDERS = "GET_CART_BUNDLE_ID_ORDERS";
export const GET_CART_BUNDLE_ID_ORDERS_RESPONSE =
  "GET_CART_BUNDLE_ID_ORDERS_RESPONSE";

export const GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY =
  "GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY";
export const GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY_RESPONSE =
  "GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY_RESPONSE";

export const GET_ALL_ORDERS_BY_CARTBUNDLEID = "GET_ALL_ORDERS_BY_CARTBUNDLEID";
export const GET_ALL_ORDERS_BY_CARTBUNDLEID_RESPONSE =
  "GET_ALL_ORDERS_BY_CARTBUNDLEID_RESPONSE";

export const GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES =
  "GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES";
export const GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES_RESPONSE =
  "GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES_RESPONSE";

export const UPDATE_ORDERS_STATUS_BY_CARTBUNDLEID =
  "UPDATE_ORDERS_STATUS_BY_CARTBUNDLEID";

// ===== Product =====
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const GET_ALL_PRODUCT = "GET_ALL_PRODUCT";
export const GET_ALL_PRODUCT_RESPONSE = "GET_ALL_PRODUCT_RESPONSE";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_RESPONSE = "GET_PRODUCT_RESPONSE";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";
export const GET_PRODUCT_BY_CATEGORY_ID = "GET_PRODUCT_BY_CATEGORY_ID";
export const GET_PRODUCT_BY_CATEGORY_ID_RESPONSE =
  "GET_PRODUCT_BY_CATEGORY_ID_RESPONSE";
export const GET_ACTIVE_PRODUCTS = "GET_ACTIVE_PRODUCTS";
export const GET_ACTIVE_PRODUCTS_RESPONSE = "GET_ACTIVE_PRODUCTS_RESPONSE";
export const GET_ALL_PRODUCT_BY_CATEGORY_ID = "GET_ALL_PRODUCT_BY_CATEGORY_ID"
export const GET_ALL_PRODUCT_BY_CATEGORY_ID_RESPONSE = "GET_ALL_PRODUCT_BY_CATEGORY_ID_RESPONSE"

// ===== Review =====
export const CREATE_REVIEW = "CREATE_REVIEW";
export const DELETE_REVIEW = "DELETE_REVIEW";
export const GET_ALL_REVIEW = "GET_ALL_REVIEW";
export const GET_ALL_REVIEW_RESPONSE = "GET_ALL_REVIEW_RESPONSE";
export const GET_REVIEW = "GET_REVIEW";
export const GET_REVIEW_RESPONSE = "GET_REVIEW_RESPONSE";
export const UPDATE_REVIEW = "UPDATE_REVIEW";

// TOP SELLING PRODUCTS
export const GET_TOP_SELLING_PRODUCTS = "GET_TOP_SELLING_PRODUCTS";
export const GET_TOP_SELLING_PRODUCTS_RESPONSE =
  "GET_TOP_SELLING_PRODUCTS_RESPONSE";

// total sales
export const GET_TOTAL_SALES = "GET_TOTAL_SALES";
export const GET_TOTAL_SALES_RESPONSE = "GET_TOTAL_SALES_ RESPONSE ";

// total orders
export const GET_TOTAL_ORDERS = "GET_TOTAL_ORDERS";
export const GET_TOTAL_ORDERS_RESPONSE = "GET_TOTAL_ORDERS_RESPONSE";

// pendingCount
export const GET_PENDING_COUNT = "GET_PENDING_COUNT";
export const GET_PENDING_COUNT_RESPONSE = "GET_PENDING_COUNT_RESPONSE";

// packed count
export const GET_PACKED_COUNT = "GET_PACKED_COUNT";
export const GET_PACKED_COUNT_RESPONSE = "GET_PACKED_COUNT_RESPONSE";

// ShippedCount
export const GET_SHIPPED_COUNT = "GET_SHIPPED_COUNT";
export const GET_SHIPPED_COUNT_RESPONSE = "GET_SHIPPED_COUNT_RESPONSE";

//DeliveredCount
export const GET_DELIVERED_COUNT = "GET_DELIVERED_COUNT";
export const GET_DELIVERED_COUNT_RESPONSE = "GET_DELIVERED_COUNT_RESPONSE";

//CancelledCount
export const GET_CANCELLED_COUNT = "GET_CANCELLED_COUNT";
export const GET_CANCELLED_COUNT_RESPONSE = "GET_CANCELLED_COUNT_RESPONSE";

// ===== User =====
export const CREATE_USER = "CREATE_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_ALL_USER = "GET_ALL_USER";
export const GET_ALL_USER_RESPONSE = "GET_ALL_USER_RESPONSE";
export const GET_USER = "GET_USER";
export const GET_USER_RESPONSE = "GET_USER_RESPONSE";
export const UPDATE_USER = "UPDATE_USER";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_RESPONSE = "LOGIN_USER_RESPONSE";
export const VALIDATE_OTP = "VALIDATE_OTP";
export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
// ===== GenerateToken =====
export const CREATE_AUTH = "CREATE_AUTH";
export const AUTH_USER_RESPONSE = "AUTH_USER_RESPONSE";
export const LOGOUT_USER = "LOGOUT_USER";

// ===== Calculation =====
export const CREATE_CALCULATION = "CREATE_CALCULATION";
export const DELETE_CALCULATION = "DELETE_CALCULATION";
export const GET_ALL_CALCULATION = "GET_ALL_CALCULATION";
export const GET_ALL_CALCULATION_RESPONSE = "GET_ALL_CALCULATION_RESPONSE";
export const GET_CALCULATION = "GET_CALCULATION";
export const GET_CALCULATION_RESPONSE = "GET_CALCULATION_RESPONSE";
export const UPDATE_CALCULATION = "UPDATE_CALCULATION";
export const GET_CALCULATION_BY_CARDBUNDLE_ID = "GET_CALCULATION_BY_CARDBUNDLE_ID";

// ===== Otp =====
export const CREATE_OTP = "CREATE_OTP";

// ===== RazorPay =====
export const CREATE_RAZORPAY = "CREATE_RAZORPAY";
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const PEYMENT_DETAILS_RESPONSES = "PEYMENT_DETAILS_RESPONSES";


//=====contact-us ====
export const GET_ALL_CONTACT_AS = "GET_ALL_CONTACT_AS";
export const GET_ALL_CONTACT_AS_RESPONSE = "GET_ALL_CONTACT_AS_RESPONSE";

// ===== State =====
export const CREATE_STATE = "CREATE_STATE";
export const DELETE_STATE = "DELETE_STATE";
export const GET_ALL_STATE = "GET_ALL_STATE";
export const GET_ALL_STATE_RESPONSE = "GET_ALL_STATE_RESPONSE";
export const GET_STATE = "GET_STATE";
export const GET_STATE_RESPONSE = "GET_STATE_RESPONSE";
export const UPDATE_STATE = "UPDATE_STATE";

// UI
export const SET_PANEL = "SET_PANEL";
export const MODIFY_PANEL = "MODIFY_PANEL";
export const SET_THEME = "SET_THEME";

//Delhivery
export const SCHEDULE_PICKUP = "SCHEDULE_PICKUP";
export const CREATE_SHIPMENT = "CREATE_SHIPMENT";
export const GET_SHIPMENT = "GET_SHIPMENT";
export const GET_SHIPMENT_RESPONSES = "GET_SHIPMENT_RESPONSES";

export const GET_PACKAGE_DETAILS = "GET_PACKAGE_DETAILS";
export const GET_PACKAGE_DETAILS_RESPONSES = "GET_PACKAGE_DETAILS_RESPONSES";
export const UPDATE_PACKAGE_DETAILS = "UPDATE_PACKAGE_DETAILS";
export const GET_RECEIPT = "GET_RECEIPT";

// ===== SupportTickets =====
export const ADD_CHAT_MESSAGE = "ADD_CHAT_MESSAGE";
export const CREATE_SUPPORT_TICKET = "CREATE_SUPPORT_TICKET";
export const DELETE_SUPPORT_TICKET = "DELETE_SUPPORT_TICKET";
export const GET_ALL_SUPPORT_TICKET = "GET_ALL_SUPPORT_TICKET";
export const GET_ALL_SUPPORT_TICKET_RESPONSE = "GET_ALL_SUPPORT_TICKET_RESPONSE";
export const GET_SUPPORT_TICKETS_BY_STATUS = "GET_SUPPORT_TICKETS_BY_STATUS";
export const GET_SUPPORT_TICKETS_BY_STATUS_RESPONSE = "GET_SUPPORT_TICKETS_BY_STATUS_RESPONSE";
export const GET_SUPPORT_TICKET_BY_ID = "GET_SUPPORT_TICKET_BY_ID";
export const GET_SUPPORT_TICKET_BY_ID_RESPONSE = "GET_SUPPORT_TICKET_BY_ID_RESPONSE";
export const UPDATE_SUPPORT_TICKET = "UPDATE_SUPPORT_TICKET";
export const GET_OLD_MESSAGES = "GET_OLD_MESSAGES";
export const GET_OLD_MESSAGES_RESPONSES = "GET_OLD_MESSAGES_RESPONSES";
export const  UPDATE_UNSEEN_CHAT = "UPDATE_UNSEEN_CHAT";
export const END_CHAT_SESSION = "END_CHAT_SESSION";


